<template>
  <td
    class="has-text-right km-cell"
    :class="{
      'has-background-danger-light': hasGap,
      'is-editable': isAdmin,
      'is-editing': isEditing
    }"
    @click="onCellClick"
  >
    <div v-if="isEditing" class="km-edit" @click.stop>
      <input
        ref="input"
        class="input is-small km-edit-input"
        type="number"
        min="0"
        step="1"
        :value="editValue"
        :disabled="saving"
        @input="$emit('update:editValue', $event.target.value)"
        @keydown.enter.prevent="$emit('save')"
        @keydown.esc.prevent="$emit('cancel')"
      >
      <div v-if="dirty" class="km-edit-actions">
        <button
          type="button"
          class="button is-small is-success"
          :disabled="saving"
          @click="$emit('save')"
        >Gem</button>
        <button
          type="button"
          class="button is-small"
          :disabled="saving"
          @click="$emit('cancel')"
        >Fortryd</button>
      </div>
    </div>
    <span v-else>{{ displayValue }}</span>
  </td>
</template>

<script>
import { defineComponent } from 'vue'
import { formatNumber } from '@/forbrug/formatters'

export default defineComponent({
  name: 'ForbrugKmCell',
  props: {
    value: { type: [Number, String], default: 0 },
    field: { type: String, required: true },
    isAdmin: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    editValue: { type: String, default: '' },
    dirty: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    hasGap: { type: Boolean, default: false }
  },
  emits: ['start-edit', 'update:editValue', 'save', 'cancel'],
  computed: {
    displayValue() {
      return formatNumber(this.value)
    }
  },
  watch: {
    isEditing(editing) {
      if (editing) {
        this.$nextTick(() => {
          const el = this.$refs.input
          if (el && el.focus) {
            el.focus()
            el.select()
          }
        })
      }
    }
  },
  methods: {
    onCellClick() {
      if (!this.isAdmin || this.isEditing) return
      this.$emit('start-edit', this.field)
    }
  }
})
</script>
